<template>
  <v-card flat class="pa-10" @click:outside="closeDialogs">
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card-title>
          {{ $t("Enter old password") }}
        </v-card-title>
        <v-text-field
          :label="$t('Old password')"
          outlined
          flat
          dense
          name="password"
          v-model="oldPassword"
          prepend-inner-icon="mdi-lock-outline"
          :rules="[validateOldPassword]"
          :error-messages="$t(errors.oldPassword)"
          type="password"
          @keydown.enter="submitOldPassword"
          class="mx-4"
        />
        <v-card-actions class="d-flex justify-end">
          <v-btn outlined color="primary" @click="closeDialogs" class="mr-10">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn outlined color="primary" @click="submitOldPassword">
            {{ $t("Submit") }}
          </v-btn>
        </v-card-actions>
      </v-tab-item>
      <v-tab-item>
        <v-card-title>
          {{ $t("Enter new password") }}
        </v-card-title>
        <div class="mx-4">
          <v-text-field
            :label="$t('Password')"
            outlined
            flat
            dense
            name="password"
            v-model="password"
            prepend-inner-icon="mdi-lock-outline"
            :rules="[validatePassword]"
            :error-messages="$t(errors.password)"
            type="password"
            @keydown.enter="updatePassword"
          />
          <v-text-field
            :label="$t('Confirm password')"
            outlined
            flat
            dense
            name="confirmPassword"
            v-model="confirmPassword"
            prepend-inner-icon="mdi-lock-outline"
            :rules="[validateConfirmPassword]"
            :error-messages="$t(errors.confirmPassword)"
            type="password"
            @keydown.enter="updatePassword"
          />
        </div>
        <v-card-actions class="d-flex justify-end">
          <v-btn outlined color="primary" @click="closeDialogs" class="mr-10">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn outlined color="primary" @click="updatePassword">
            {{ $t("Update") }}
          </v-btn>
        </v-card-actions>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="changePasswordSuccessDialog" width="40vw" persistent>
      <v-card flat class="pa-4">
        <v-card-title>
          {{ $t("Your password has been successfully updated") }}
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn outlined color="primary" @click="closeDialogs">
            {{ $t("Done") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import AuthService from "@/service/auth_service";

export default {
  props: ["init"],

  data() {
    return {
      oldPassword: "",
      password: "",
      confirmPassword: "",
      tab: 0,
      errors: {},
      changePasswordSuccessDialog: false
    };
  },

  methods: {
    async submitOldPassword() {
      try {
        await AuthService.verifyPassword(this.oldPassword);
        this.tab++;
      } catch (error) {
        this.errors.oldPassword = "Wrong password";
        this.errors = { ...this.errors };
      }
    },

    async updatePassword() {
      try {
        await AuthService.updatePassword(this.password);
        this.changePasswordSuccessDialog = true;
      } catch (error) {
        switch (error.message) {
          case "email-already-in-use":
          case "invalid-email":
            this.errors.email = error.message;
            break;
          case "operation-not-allowed":
            break;
          case "weak-password":
            this.errors.password = error.message;
            break;
        }
        this.errors = { ...this.errors };
        return false;
      }
    },

    validateOldPassword() {
      if (this.errors.oldPassword) {
        return this.errors.oldPassword;
      }
      return this.oldPassword ? true : "This field is required";
    },

    validatePassword() {
      return this.password && this.password.length > 6
        ? true
        : "Password should contain at least 6 characters";
    },

    validateConfirmPassword() {
      return this.confirmPassword && this.confirmPassword === this.password
        ? true
        : "Your passwords do not match";
    },

    closeDialogs() {
      this.changePasswordSuccessDialog = false;
      this.$emit("close");
    }
  }
};
</script>
